"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dLog = void 0;
var dLog = function (log, debug) {
    if (debug) {
        console.log(log);
    }
};
exports.dLog = dLog;
